import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { nextQuestionId: Number }

  submit(event) {
    event.preventDefault()

    const form = document.getElementById('new_question_form')
    if (!form) return

    // Set verified to true
    let verifiedInput = form.querySelector('input[name="question[verified]"][type="hidden"]')
    if (!verifiedInput) {
      verifiedInput = document.createElement('input')
      verifiedInput.type = 'hidden'
      verifiedInput.name = 'question[verified]'
      form.appendChild(verifiedInput)
    }
    verifiedInput.value = '1'

    // Set next_question_id for redirect
    if (this.hasNextQuestionIdValue) {
      let nextInput = form.querySelector('input[name="question[next_question_id]"]')
      if (!nextInput) {
        nextInput = document.createElement('input')
        nextInput.type = 'hidden'
        nextInput.name = 'question[next_question_id]'
        form.appendChild(nextInput)
      }
      nextInput.value = this.nextQuestionIdValue
    }

    form.requestSubmit()
  }
}
